var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mit-my-borrowed-list"},[_c('MitDataTableClient',{attrs:{"title":"Borrowed","editable":false,"headers":_vm.headers,"items":_vm.borrowed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }